<div class="form-group selector-class">
  <ng-container *ngIf="processing">
    <i class="far fa-spinner fa-spin"></i>
    <span class="ms-2">{{ 'AbpUi::ProcessingWithThreeDot' | abpLocalization }}</span>
  </ng-container>

  <ng-container *ngIf="!processing">
    <div>
      <div class="entity-container">
        <div class="w-100 fw-bold ms-3 d-flex align-items-center">
          <span class="me-2">
            {{ 'Settings::PhraseType.CustomEntity.Category' | abpLocalization }}
          </span>
          <div [ngbTooltip]="addCustomPhraseTypeMessage" [container]="'body'">
            <button
              type="button"
              class="btn ca-btn ca-btn-neutral-toolbar toolbar-button"
              (click)="openModal()"
              [disabled]="customPhraseTypeList.length >= maxPatternLimit">
              <i class="far fa-plus-circle"></i>
            </button>
          </div>
        </div>
        <div *ngFor="let customType of customPhraseTypeList" class="entity-column">
          <div class="entity-column-label">
            <div class="display-inline">
              <input
                id="custom-phrase-type-{{ customType.id }}"
                type="checkbox"
                [checked]="isSelected(customType)"
                (change)="onCustomEntityChange($event, customType)" />
              <label>
                <span class="clickable-label" (click)="openModal(customType)">
                  {{ customType.name }}
                </span>
                <small class="form-text text-muted ps-1">
                  {{ getIsoLanguageCodes(customType.languages) }}
                </small>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #customPhraseTypeModal let-modal>
  <form [formGroup]="customForm">
    <div class="modal-header d-flex justify-content-between align-items-start">
      <div>
        <h5 class="modal-title">
          {{ 'Settings::PhraseType.CustomEntity' | abpLocalization }}
        </h5>
        <small class="text-muted">
          {{ 'Settings::PhraseType.CustomEntityRegexBasedDescription' | abpLocalization }}
        </small>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-light border rounded-circle"
        [ngbPopover]="auditLogTemplate"
        popoverClass="custom-phrase-type-popover"
        placement="left-top"
        container="body"
        triggers="click"
        [autoClose]="'outside'"
        *ngIf="customPhraseTypeDto">
        <i class="bi bi-file-earmark-text"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="row mb-3">
        <label for="name" class="col-sm-4 col-form-label indicates-required-field">
          {{ 'Settings::PhraseType.CustomEntityName' | abpLocalization }}
        </label>
        <div class="col-sm-8 ps-0">
          <input
            id="name"
            type="text"
            class="form-control form-control-sm"
            [placeholder]="'Settings::PhraseType.CustomEntityName.Placeholder' | abpLocalization"
            formControlName="name" />
        </div>
      </div>
      <div class="row mb-3">
        <label class="col-sm-4 col-form-label indicates-required-field">
          {{ '::Language' | abpLocalization }}
        </label>
        <div class="col-sm-8 ps-0">
          <ng-select
            id="languages"
            formControlName="languages"
            [placeholder]="'::SelectLanguage' | abpLocalization"
            bindLabel="name"
            bindValue="code"
            [items]="languagesDataSource"
            [multiple]="true"
            [closeOnSelect]="false"
            appendTo=".modal-body">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                [ngModelOptions]="{ standalone: true }" />
              {{ 'Settings::Call.Language.' + item.name | abpLocalization }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <span
                class="ng-value-icon left"
                aria-hidden="true"
                (click)="removeFromSelectedLanguages(item.code)">
                ×
              </span>
              <span class="ng-value-label">
                {{ 'Settings::Call.Language.' + item.name | abpLocalization }}
              </span>
            </ng-template>
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="ng-value">
                <span class="ng-value-label">
                  {{ 'CA::XItemsSelected' | abpLocalization: items.length }}
                </span>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="row align-items-start">
        <div class="col-sm-4 d-flex flex-column">
          <label for="regexInput" class="col-form-label indicates-required-field mb-0">
            {{ 'Settings::PhraseType.CustomEntityExpressions' | abpLocalization }}
          </label>
        </div>
        <div class="col-sm-8 ps-0 d-flex flex-column">
          <input
            type="text"
            id="regexInput"
            formControlName="currentRegexInput"
            class="form-control form-control-sm"
            [placeholder]="
              'Settings::PhraseType.CustomEntityExpressions.Placeholder' | abpLocalization
            "
            (keydown.enter)="addRegex()" />
          <div
            *ngIf="customForm.get('currentRegexInput')?.value"
            class="mt-1 px-2 py-1 border rounded bg-light text-muted small"
            (click)="addRegex()">
            {{ 'Settings::PhraseType.CustomEntityExpressionsInputDescription' | abpLocalization }}
            <code>{{ customForm.get('currentRegexInput')?.value }}</code>
          </div>
          <span>
            <small
              class="text-muted"
              [innerHTML]="
                'Settings::PhraseType.CustomEntityExpressionsDescription' | abpLocalization
              "></small>
            <small>{{ ' ' }}</small>
            <small
              [innerHTML]="
                'Settings::PhraseType.CustomEntityExpressionsDescriptionRegexGuide'
                  | abpLocalization
              "></small>
          </span>
          <div class="table-scroll-area">
            <table
              mat-table
              [dataSource]="regexPatternDataSource"
              class="mat-elevation-z2 w-100"
              aria-describedby="RegexDetailsTable">
              <ng-container matColumnDef="regexPattern">
                <td mat-cell *matCellDef="let element; let i = index" class="regex-pattern-cell">
                  <div
                    *ngIf="editIndex !== i; else editBlock"
                    (click)="startEditing(i, element)"
                    class="editable-label">
                    {{ element }}
                  </div>
                  <ng-template #editBlock>
                    <div [formGroup]="editingForm" class="d-flex align-items-center">
                      <div class="flex-grow-1 me-2 overflow-hidden">
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          formControlName="editedRegexInput"
                          (keydown.enter)="onEnterKey($event, i)"
                          (blur)="saveEditing(i)"
                          autofocus />
                      </div>
                      <button
                        type="button"
                        class="btn btn-link text-success p-0 me-1"
                        (click)="saveEditing(i)">
                        <i class="fas fa-check"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-link text-danger p-0"
                        (mousedown)="$event.preventDefault(); cancelClick = true"
                        (click)="cancelEditing()">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </ng-template>
                  <div *ngIf="activeTestIndex === i" class="d-flex align-items-center mt-2 mb-2">
                    <input
                      type="text"
                      class="form-control form-control-sm me-2"
                      placeholder="Enter target value"
                      [(ngModel)]="regexTestTarget"
                      [ngClass]="{
                        'border-success': regexTestResult === true,
                        'border-danger': regexTestResult === false,
                      }"
                      [ngModelOptions]="{ standalone: true }" />

                    <i
                      *ngIf="regexTestResult === true"
                      class="fas fa-check-circle text-success fs-5 me-1"></i>
                    <i
                      *ngIf="regexTestResult === false"
                      class="fas fa-times-circle text-danger fs-5 me-1"></i>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <td mat-cell *matCellDef="let element; let i = index" class="actions-cell">
                  <div class="d-flex flex-column align-items-end">
                    <div>
                      <button
                        [hidden]="activeTestIndex === i"
                        type="button"
                        class="btn ca-btn ca-btn-neutral-toolbar toolbar-button"
                        ngbTooltip="{{ 'AbpUi::Delete' | abpLocalization }}"
                        (click)="deleteRegexPattern(i)">
                        <ca-delete-icon></ca-delete-icon>
                      </button>
                      <button
                        [hidden]="activeTestIndex === i"
                        type="button"
                        class="btn ca-btn ca-btn-neutral-toolbar toolbar-button"
                        ngbTooltip=" {{ '::Test' | abpLocalization }}"
                        (click)="toggleRegexTest(i)">
                        <i class="fas fa-bullseye"></i>
                      </button>
                    </div>
                    <div
                      *ngIf="activeTestIndex === i"
                      class="mt-2 pb-3 d-flex align-items-center justify-content-end gap-3">
                      <button
                        class="btn btn-link p-0 m-0 text-primary text-decoration-none"
                        (click)="performRegexTest(element)">
                        {{ '::Test' | abpLocalization }}
                      </button>
                      <button
                        class="btn btn-link p-0 m-0 pe-1 text-muted text-decoration-none"
                        (click)="toggleRegexTest(null)">
                        {{ 'AbpUi::Close' | abpLocalization }}
                      </button>
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="info">
                <td
                  mat-footer-cell
                  *matFooterCellDef
                  style="text-align: left"
                  [attr.colspan]="columnsToDisplay.length">
                  <i class="fas fa-info-circle me-1 ms-1"></i>
                  <span class="ms-2">
                    {{ regexPatternDataSource.length }} / {{ maxPatternLimit }}
                  </span>
                </td>
              </ng-container>

              <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
              <tr mat-footer-row *matFooterRowDef="['info']; sticky: true"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="btn-toolbar d-flex flex-wrap align-items-stretch justify-content-end">
        <div
          [ngbTooltip]="
            'Settings::PhraseType.CustomEntity.DeletionDisabledDescription' | abpLocalization
          "
          [disableTooltip]="!isSelected(customPhraseTypeDto)">
          <button
            type="button"
            class="btn ca-btn ca-btn-neutral"
            *ngIf="customForm.get('id').value > 0"
            [disabled]="isSelected(customPhraseTypeDto)"
            (click)="confirmDeletion($event, customPhraseTypeDto)">
            {{ 'AbpUi::Delete' | abpLocalization }}
          </button>
        </div>
        <div class="toolbar-item d-flex align-items-center" *ngIf="customForm.get('id').value > 0">
          <mat-divider [vertical]="true" class="menu-divider"></mat-divider>
        </div>
        <button type="button" (click)="closeModal()" class="btn ca-btn ca-btn-neutral me-2">
          {{ 'AbpUi::Cancel' | abpLocalization }}
        </button>
        <button
          type="button"
          class="btn ca-btn ca-btn-primary"
          [disabled]="processing"
          (click)="saveCustomPhraseType(modal)">
          <i class="far fa-save me-1"></i>
          <span>{{ 'AbpUi::Save' | abpLocalization }}</span>
        </button>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #auditLogTemplate>
  <div class="audit-log-box">
    <div class="fw-semibold mb-2">{{ 'AbpAuditLogging::AuditLogs' | abpLocalization }}</div>
    <div class="d-flex justify-content-between small text-muted">
      <div class="text-truncate" style="max-width: 150px">
        <strong>{{ '::CreatedBy' | abpLocalization }}</strong>
        <br />
        <span class="d-inline-block text-truncate w-100">
          {{ customPhraseTypeDto?.creatorFullName || '-' }}
        </span>
      </div>
      <div class="text-truncate" style="max-width: 150px">
        <strong>{{ '::ModifiedBy' | abpLocalization }}</strong>
        <br />
        <span class="d-inline-block text-truncate w-100">
          {{ customPhraseTypeDto?.lastModifierFullName || '-' }}
        </span>
      </div>
      <div class="text-truncate" style="max-width: 180px">
        <strong>{{ '::ModificationTime' | abpLocalization }}</strong>
        <br />
        <span class="d-inline-block text-truncate w-100">
          {{
            customPhraseTypeDto?.lastModificationDate
              ? (customPhraseTypeDto.lastModificationDate
                | caDatePipe: dateDisplayType.DateTimeWithoutSeconds : true)
              : ''
          }}
        </span>
      </div>
    </div>
  </div>
</ng-template>
